<template>
  <Modal title="获取投保链接" width="890" v-model="visible" class="directional-policy" :mask-closable="false" :footer-hide="true">
    <div class="form-box">
      <div class="title-box">
        <div class="num">1</div>
        <div class="text">填写投保人信息</div>
      </div>
      <div class="row" v-if="!hideAreaCodes.includes(formData.productCode)">
        <div class="label">投保区域</div>
        <Select v-model="formData.areaName" filterable v-if="areaType==1">
          <Option v-for="(item, i) in areaColumns" :value="item" :key="i">{{
            item
          }}</Option>
        </Select>
        <Cascader v-if="areaType==2" :data="areaColumns" v-model="formData.areaName" />
        <div class="info-text">您可以选择户籍、工作或家庭住址所在的省份作为投保区域</div>
      </div>
      <div class="row">
        <div class="label">投保人姓名</div>
        <input type="text" v-model.trim="formData.name" maxlength="10" placeholder="请输入姓名">
      </div>
      <div class="row" v-if="!hideCardNoCodes.includes(formData.productCode)">
        <div class="label">投保人身份证号</div>
        <input type="text" v-model.trim="formData.cardNo" placeholder="请输入身份证号">
      </div>
      <div class="row" v-if="telCodes.includes(formData.productCode)">
        <div class="label">投保人手机号</div>
        <input type="text" v-model.trim="formData.mobile" placeholder="请输入投保人手机号">
      </div>
      <Button @click="submit" class="submit-btn">获取定向链接</Button>
    </div>
    <div class="right-box">
      <div class="title-box">
        <div class="num">2</div>
        <div class="text">复制定向链接发给客户投保</div>
      </div>
      <div class="empty-box" v-show="!pcLink">
        <img src="@static/images/product/x-empty.png" alt="">
        <div>定向链接待生成</div>
      </div>
      <div class="link-box" v-show="pcLink">
        <div class="row">
          <div class="label">PC链接</div>
          <a class="text" :href="pcLink" target="_blank">{{pcLink}}</a>
          <div class="btn" @click="$units.copyUrl(pcLink,false,true)">复制</div>
        </div>
        <div class="row">
          <div class="label">手机链接</div>
          <a class="text" :href="mLink" target="_blank">{{mLink}}</a>
          <div class="btn" @click="$units.copyUrl(mLink,false,true)">复制</div>
        </div>
        <div class="row">
          <div class="label">投保二维码</div>
          <vueQr :text="mLink" v-if="mLink" :size="130" :margin="0" />
        </div>
      </div>
    </div>
    <img src="@static/images/product/x-arr.png" class="arr">
  </Modal>
</template>

<script>
import $ from 'jquery'
import vueQr from "vue-qr";
export default {
  props: [],
  components: {
    vueQr
  },
  data() {
    return {
      telCodes: fqyfProduct.dxTelCodes, //显示手机号的产品
      hideCardNoCodes: fqyfProduct.dxHideCardNoCodes, //隐藏身份证的产品
      hideAreaCodes: fqyfProduct.dxHideAreaCodes, //隐藏区域的产品
      areaColumns: [], //区域选项
      areaType:0,
      formData: {},
      visible: false,
      loading: false,
      pcLink: '',
      mLink: '',
      productCode: '',
    }
  },
  mounted() {},
  methods: {
    // 打开弹窗
    open(data) {
      this.visible = true
      this.formData = {
        productCode:data.productCode
      }
      this.productCode = data.productCode;
      this.pcLink = ''
      this.mLink = ''
      this.areaType = 0;
      this.getAreaData()
      console.log(this.$config.base)
    },
    getStotLink(url) {
      let ajaxUrl = '/buz/orderImport/transformLongUrl'
      this.$http({
        type: 'PUT',
        url: ajaxUrl,
        data: {
          url: url.replace('/m/product/','/product/'),
        },
      }).then((res) => {
        this.pcLink = res.data
      })
      this.$http({
        type: 'PUT',
        url: ajaxUrl,
        data: {
          url: url,
        },
      }).then((res) => {
        this.mLink = res.data
      })
    },
    //获取区域数据
    getAreaData() {
      this.$http({
        type: 'GET',
        url: '/buz/appointInsured/queryCustomInsureArea2',
        data: {
          productCode: this.productCode,
        },
      }).then((resData) => {
        const data = resData.data
        this.areaType = data.type;
        if(data.type==1&&data.area){
          this.$set(this.formData, "areaName", "");
          this.areaColumns = data.area.split(",");
        }else if(data.type==2&&data.area){
          this.$set(this.formData, "areaName", []);
          this.formatData(data.area)
          this.areaColumns = data.area;
        }else{
          this.areaColumns = [];
        }
      })
    },
    formatData(data){
      if(data&&data.length){
        data.forEach(item=>{
          item.value = item.name;
          item.label = item.name;
          this.formatData(item.children);
        })
      }
    },
    yz() {
      if (!this.hideAreaCodes.includes(this.formData.productCode)) {
        if (!this.formData.areaName || this.formData.areaName.length == 0) {
          this.$notice.msg('请选择投保区域')
          return
        }
      }
      
      if (!this.formData.name) {
        this.$notice.msg('请输入投保人姓名')
        return
      }
      const hzREG = /[·\u4e00-\u9fa5]+/
      if (!hzREG.test(this.formData.name)) {
        this.$notice.msg('投保人姓名只能是汉字')
        return
      }
      // 身份证验证
      if (!this.hideCardNoCodes.includes(this.formData.productCode)) {
        if (!this.formData.cardNo) {
          this.$notice.msg('请输入投保人身份证号')
          return
        }
        const idREG = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
        if (!idREG.test(this.formData.cardNo)) {
          this.$notice.msg('身份证号格式有误')
          return
        }
      }
      
      // 验证手机号
      if(this.telCodes.includes(this.formData.productCode)) {
        if(!this.formData.mobile){
          this.$notice.msg("请输入手机号码")
          return;
        }
        const telREG = /^1\d{10}$/
        if(!telREG.test(this.formData.mobile)){
          this.$notice.msg("手机号码格式有误")
          return;
        }
      }
      return true
    },
    // 提交
    submit() {
      if (this.loading || !this.yz()) {
        return
      }
      this.loading = true
      const query = {}
      query.productCode = this.productCode
      query.userId = JSON.parse(localStorage.getItem("userInfo")).userid
      const formData = JSON.parse(JSON.stringify(this.formData));
      formData.channelSign = "BPS_JD"
      if(this.areaType==2){
        formData.areaName = formData.areaName.join('');
      }
      this.$http({
        type: 'POST',
        url: '/buz/userBase/createSeedUrl',
        query: query,
        data: formData,
      })
        .then((resData) => {
          this.getStotLink(resData.data)
        })
        .finally((e) => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import './directionalPolicy.scss';
</style>
